import { isObject, mapKeys, mapValues } from 'lodash-es';

export const mapKeysDeep = (object: object, mapper: (_value: any, key: string) => string): object => Array.isArray(object)
	? object.map(value => (isObject(value) ? mapKeysDeep(value, mapper) : value))
	: mapValues(
		mapKeys(object, mapper),
		value => (isObject(value) ? mapKeysDeep(value, mapper) : value),
	);
